import { useCallback, useMemo, useState } from "react";
var useFnUpdateCertificate = function () {
    var _a = useState(), updateBodyRequest = _a[0], setUpdateBodyRequest = _a[1];
    var updateCertificate = useCallback(function (data, fileName, typeFile, setTriggerUpdate) {
        setUpdateBodyRequest({
            title: fileName,
            type: typeFile,
            fileName: fileName,
            html: data,
            physicalName: fileName,
            quickPrintable: false,
        });
        setTriggerUpdate(true);
    }, []);
    return useMemo(function () { return ({
        updateCertificate: updateCertificate,
        updateBodyRequest: updateBodyRequest,
    }); }, [updateCertificate, updateBodyRequest]);
};
export default useFnUpdateCertificate;
